import axios from "axios";
import { toast } from "react-toastify";
import i18next from "i18next";
import PubSub from "pubsub-js";

const EVENTS = {
  KICK_USER: "KICK_USER",
};

export const responseErrorHandler = (error: { response: { data: any } }) => {
  const {
    response: { data },
  } = error;
  const EXPIRED_SESSION_MESSAGE = "INVALID_SESSION_EXCEPTION";
  const COULD_NOT_COMPLETE_YOUR_REQUEST = "could not complete your request";
  const ASTREA_VIOLATIONS = "astrea_violations";
  const code = data ? data.statusCode || data.error.code : 500;
  let message = data ? data.errorMessage || data.error.message : "";
  if (code === 400) {
    toast.error(String(i18next.t(message)));
  } else if (code === 401 && message === EXPIRED_SESSION_MESSAGE) {
    return PubSub.publish(EVENTS.KICK_USER);
  } else if (code === 503 && !message.includes(ASTREA_VIOLATIONS)) {
    console.error(i18next.t("Serviço indisponível. Tente novamente mais tarde."));
  } else if (code === 410) {
    toast.error(message);
  } else if (message.includes(COULD_NOT_COMPLETE_YOUR_REQUEST)) {
    toast.error(
      String(
        i18next.t("Não foi possivel completar a requisição. Recarregue a página e tente novamente.")
      )
    );
  }
  return Promise.reject(error);
};

export const setAxiosResponseErrorHandler = () => {
  axios.interceptors.response.use((response) => response, responseErrorHandler);
};

export const handleRequestErrorViolations = (error: { response: any }) => {
  if (!error.response) return;
  const {
    response: {
      data: {
        error: { errors = [] },
      },
    },
  } = error;

  const isVersionError = errors.some(({ message }: { message: string }) =>
    message.includes("astrea_violations<>0801")
  );
  if (isVersionError) toast("A tarefa está desatualizada. Por favor, atualize a página.");
  else toast.error("Ops, algo deu errado, tente novamente ou entre em contato com o suporte.");
  throw error;
};
